import { Span } from "@vp/swan";
import React from "react";
import { useLocalization } from "../../hooks/useLocalizations";
import { IUnitPrice } from "../../types/pricing";
import ComparativePrice from "./ComparativePrice";
import VatMessage from "./VatMessage";

interface AsLowAsPricePerPieceProps {
  pricingInfo: IUnitPrice;
  /** @deprecated ignored; synchronous rendering */
  placeHolderText?: string;
  /** @deprecated use className instead */
  classNameWrapper?: string;
  className?: string;
  /** @deprecated not used */
  tenant?: string;
}

const AsLowAsPricePerPiece: React.FC<AsLowAsPricePerPieceProps> = ({
  pricingInfo,
  classNameWrapper,
  className,
}) => {
  const { t } = useLocalization();
  const wrapperClass = classNameWrapper || className;
  const prefix = t("price-platform.token-price.as-low-as-prefix");
  const suffix = t("price-platform.token-price.per-piece-suffix");
  return (
    <Span className={["swan-pricing", wrapperClass].filter(Boolean).join(" ")}>
      {prefix && <Span className="swan-pricing-offer">{prefix}</Span>}
      <ComparativePrice
        listPrice={pricingInfo.unitListPrice}
        discountPrice={pricingInfo.unitDiscountPrice}
        currency={pricingInfo.currency}
        locale={pricingInfo.culture}
        minimumFractionDigits={pricingInfo.minimumFractionDigits}
      />
      {suffix && <Span className="swan-pricing-offer">{suffix}</Span>}
      {!pricingInfo.hideVatMessage && (
        <>
          {" "}
          <VatMessage
            locale={pricingInfo.culture}
            vatInc={pricingInfo.vatInc}
            hideShippingMessageInVatMessage={pricingInfo.hideShippingMessageInVatMessage}
          />
        </>
      )}
    </Span>
  );
};

export default AsLowAsPricePerPiece;
